module.exports = __webpack_public_path__ + "img/首页2-5.74e0377d.svg";